/*eslint camelcase: ["error", {properties: "never"}]*/
import { Column } from 'primereact/column';
import { DataTable } from 'primereact/datatable';
import { useSelector } from 'react-redux';
import React, { useState } from 'react';
import { datetimeToDate } from '../../../../utils/dateFormat';
import { useGetCoachingInsightFeedbackDetailsQuery } from '../../CoachingInsightSlice';
import { CoachingInsightSummary } from '../../../coachingInsightSummary/CoachingInsightSummary';
import ThumbsUpIconSelected from '../../../../assets/thumbsUpSelected.svg';
import ThumbsDownIconSelected from '../../../../assets/thumbsDownSelected.svg';
import { formatWeekRange } from '../coaching-Insight-Feedback-service';
import { selectCurrentEmpid } from '../../../../pages/login/authSlice';

interface insightFeedbackDetailsProps {
    agentNumbers: string[];
    selectedDates: Date[];
}
export const CoachingInsightFeedbackTable = ({ agentNumbers, selectedDates }: insightFeedbackDetailsProps) => {
    const [expandedRows, setExpandedRows] = useState<any>();
    const loggedEmpNum = useSelector(selectCurrentEmpid);
    const { data: insightFeedbackDataDetails } = useGetCoachingInsightFeedbackDetailsQuery(
        {
            agentNumber: agentNumbers,
            authorNumber: loggedEmpNum,
            fromDate: datetimeToDate(selectedDates[0]),
        },
        {
            skip: !agentNumbers.length || !selectedDates.length,
        }
    );
  
    const allowExpansion = (rowData: any) => {

        if (rowData) return true;
        else return false;
    };
    const rowExpansionTemplate = (rowData: any) => {
        return (
            <div className="card mt-1 border-0">
                <div className="card-header border-0" style={{ backgroundColor: '#ebf2f9', padding: '5px' }}>
                    Feedback Details
                </div>
                <CoachingInsightSummary
                    data={[rowData]}
                    via="feedbackHistory"
                />
            </div>
        )
    };
    const renderRatingIcon = (rating: boolean | undefined) => {
        if (rating === true) {
            return <img src={ThumbsUpIconSelected} alt="agree" />;
        }
        if (rating === false) {
            return <img src={ThumbsDownIconSelected} alt="disagree" />;
        }
        return '--';
    };
    
    const formatInsightsBody = (type: string) => {
        const ratingMapping: { [key: string]: any } = {
            'Coaching Points': 'coaching_points_rating',
            'Strengths': 'strengths_rating',
            'Technical Issues': 'technical_issues_rating'
        };
    
        const ratingKey = ratingMapping[type];
        
        return (rowData: any) => renderRatingIcon(rowData[ratingKey]);
    };

    
    return (
        <div className="row" style={{ width: '100%' }}>
            <DataTable
                style={{ width: '100%' }}
                id='coaching-summary'
                value={agentNumbers.length>0?insightFeedbackDataDetails?.data:[]}
                rows={5}
                paginator={insightFeedbackDataDetails?.data?.length > 5}
                paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
                rowsPerPageOptions={[5, 10, 25, 50]}
                currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
                emptyMessage="No records found."
                rowExpansionTemplate={rowExpansionTemplate}
                expandedRows={expandedRows}
                onRowToggle={(e) => {
                    setExpandedRows(e.data);
                } }
            >
                <Column header="Associate" field="employee_name" style={{ width: '5rem' }}
                    sortable />
                <Column
                    header="Week"
                    style={{ width: '5rem' }}
                    sortable
                    sortField='startDate'
                    body={formatWeekRange} />
                <Column
                    header="No. of Calls"
                    field="call_count"
                    sortable
                    style={{ width: '3rem' }} />
                <Column
                    header="Coaching Points"
                    field="coaching_points_rating"
                    sortable
                    style={{ width: '3rem' }}
                    body={formatInsightsBody('Coaching Points')} />
                <Column
                    header="Strengths"
                    field="strengths_rating"
                    sortable
                    style={{ width: '3rem' }}
                    body={formatInsightsBody('Strengths')} />
                <Column
                    header="Technical Issues"
                    field="technical_issues_rating"
                    sortable
                    style={{ width: '3rem' }}
                    body={formatInsightsBody('Technical Issues')} />
                <Column key="expand" expander={allowExpansion} style={{ width: '1rem', textAlign: 'center' }} />
            </DataTable>
        </div>
    );
};
